/* Single source of truth for logging out of the browser.
   Every credential key the app writes at login (Login.js) or while an admin
   impersonates a studio (AdminPanel.js) must be cleared here. The scattered
   per-page handlers used to remove only token/userId/userEmail, which left
   the admin_* stash behind after logout: the "Viewing as … / Switch back to
   Admin" banner kept rendering, and worse, the stored admin_token let anyone
   at the machine restore a full admin session with one click. */
const AUTH_KEYS = [
  "token",
  "userId",
  "userEmail",
  "userRole",
  "studioSlug",
  "admin_token",
  "admin_userId",
  "admin_userEmail",
  "admin_userRole",
];

export function clearAuthStorage() {
  AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
}
